import "./SettingsContent.css";
import { useEffect, useState, useCallback } from "react";
import SettingsDisplay from "./settingsDisplay";
import PreloadSettingsService from "../../../../services/PreloadService/PreloadSettingsService";
import PreloadTemplateService from "../../../../services/PreloadService/PreloadTemplateService";
import useAsync from "../../../../services/useAsync";

const SettingsContent = () => {
    const [loading, setLoading] = useState(true);

    const [currentMeme, setCurrentMeme] = useState(null);

    const { loadUserSettings, getSettings, updateUserSettings } =
        PreloadSettingsService();
    const {
        loadListOfPendingApproval,
        pendingMemes,
        approveOrDenyMeme,
        deletePendingMeme,
        pushPendingMeme,
    } = PreloadTemplateService();

    const loadPage = useCallback(async () => {
        setLoading(true);
        await Promise.all([loadListOfPendingApproval(), loadUserSettings()]);
        setLoading(false);
    }, [loadListOfPendingApproval, loadUserSettings]);

    useEffect(() => {
        // Get first meme of the array for meme approval display component
        // This will rerender the component every time there is a change on memesThatNeedApproval
        // passing along the first element of the array.
        // This needs to be top level!
        setCurrentMeme(pendingMemes[0] ? pendingMemes[0] : null);
    }, [pendingMemes]);

    useAsync(loadPage);

    return (
        <SettingsDisplay
            getSettings={getSettings}
            updateUserSettings={updateUserSettings}
            approveOrDenyMeme={approveOrDenyMeme}
            deletePendingMeme={deletePendingMeme}
            pushPendingMeme={pushPendingMeme}
            currentMeme={currentMeme}
            loading={loading}
        />
    );
};

export default SettingsContent;
